// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TF2Iz{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;overflow:hidden}.G4FM9{position:absolute;top:0;left:0;right:0;height:50%;pointer-events:none;z-index:0}.fIwm1{width:100%;height:100%}.wzGMW{align-items:center;gap:8px;text-align:center;width:100%;z-index:1}.a5YDS{color:#282863 !important;width:100%}.TqAbi{z-index:1;display:flex;justify-content:center}.emGR9{padding:12px 48px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TF2Iz`,
	"confettiArea": `G4FM9`,
	"confettiLottie": `fIwm1`,
	"textContent": `wzGMW`,
	"description": `a5YDS`,
	"ctaWrapper": `TqAbi`,
	"ctaButton": `emGR9`
};
export default ___CSS_LOADER_EXPORT___;
